const STORAGE_KEY = 'cookie-consent';
const CONSENT_VERSION = 1;

export interface CookieConsent {
  essential: true;
  functional: boolean;
  analytics: boolean;
  timestamp: number;
  version: number;
}

export function getConsent(): CookieConsent | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CookieConsent;
    if (parsed.version !== CONSENT_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function hasConsented(): boolean {
  return getConsent() !== null;
}

export function isAccepted(category: keyof Pick<CookieConsent, 'essential' | 'functional' | 'analytics'>): boolean {
  const consent = getConsent();
  if (!consent) return false;
  return consent[category];
}

export function saveConsent(preferences: Pick<CookieConsent, 'functional' | 'analytics'>): void {
  const consent: CookieConsent = {
    essential: true,
    functional: preferences.functional,
    analytics: preferences.analytics,
    timestamp: Date.now(),
    version: CONSENT_VERSION,
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
}
